import { render, staticRenderFns } from "./PatientProfileInDrawer.vue?vue&type=template&id=6882ed16&"
import script from "./PatientProfileInDrawer.vue?vue&type=script&lang=js&"
export * from "./PatientProfileInDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports